<template>
    <!-- 教学管理 -->
    <div id="Assessment">
        <el-tabs type="card">
            <el-row
                type="flex"
                justify="start"
                :gutter="20"
                style="margin-bottom:20px;"
            >
                <el-col class="widthauto">
                    <el-select
                        v-model="assForm.termId"
                        filterable
                        clearable
                        placeholder="学期"
                        @change="search"
                    >
                        <el-option
                            v-for="item in termData"
                            :key="item.id"
                            :label="item.name"
                            :value="item.id"
                        ></el-option>
                    </el-select>
                </el-col>
            </el-row>
            <el-tab-pane label="教学评估">

                <el-table
                    :data="RecordData"
                    ref="CourseData"
                    tooltip-effect="dark"
                    style="width: 100%"
                    v-loading="loading"
                    max-height="750"
                    element-loading-text="数据加载中，请稍等..."
                    element-loading-spinner="el-icon-loading"
                    element-loading-background="rgba(0, 0, 0, 0.8)"
                >
                    <el-table-column
                        label="编号"
                        type="index"
                        min-width="60"
                        :index="indexMethod"
                    >
                    </el-table-column>
                    <el-table-column
                        prop="name"
                        label="班级"
                        show-overflow-tooltip
                        min-width="50"
                    >
                        <template slot-scope="scope">
                            <a>{{scope.row.name}}</a> <span
                                v-if="scope.row.shortTraining"
                                style="color:#e4393c;font-size:14px;"
                            >(短训班)</span>
                        </template>
                    </el-table-column>
                    <el-table-column
                        prop="periodNames"
                        label="上课时间"
                    >
                        <template slot-scope="scope">
                            <span v-if="scope.row.shortTraining">
                                <el-tooltip
                                    :content="scope.row.periodNames"
                                    placement="right"
                                >
                                    <span>{{scope.row.shortTrainingStart | formatDate}}到{{scope.row.shortTrainingEnd | }}</span>
                                </el-tooltip>
                            </span>
                            <span v-else>{{scope.row.periodNames}}</span>
                        </template>
                    </el-table-column>
                    <el-table-column
                        prop="classRoomName"
                        label="教室"
                        show-overflow-tooltip
                    ></el-table-column>
                    <el-table-column
                        prop="teacherNames"
                        label="任课老师"
                        show-overflow-tooltip
                    >
                        <template slot-scope="scope">
                            <div v-if="scope.row.teacherDatas.length>1">
                                <div
                                    v-for="(item,index) in scope.row.teacherDatas"
                                    :key="index"
                                    class="bor"
                                >
                                    <span>{{item.teacherName}}</span>
                                </div>
                            </div>
                            <div v-else>
                                <div
                                    v-for="(item,index) in scope.row.teacherDatas"
                                    :key="index"
                                >
                                    <span>{{item.teacherName}}</span>
                                </div>
                            </div>

                        </template>
                    </el-table-column>
                    <el-table-column
                        prop="identityRemission"
                        label="操作"
                        show-overflow-tooltip
                    >
                        <template slot-scope="scope">
                            <div
                                v-for="(item,index) in scope.row.teacherDatas"
                                :key="index"
                                :class="scope.row.teacherDatas.length>1?'bor':''"
                            >
                                <el-button
                                    @click="assement(scope.row,index)"
                                    size="mini"
                                    v-if="scope.row.isBack &&!item.isEstimate"
                                    disabled
                                >评估</el-button>
                                <el-button
                                    @click="assement(scope.row,index)"
                                    size="mini"
                                    v-if="!scope.row.isend&&!item.isEstimate && !scope.row.isBack"
                                >评估</el-button>
                                <el-button
                                    size="mini"
                                    v-if="!scope.row.isend&&item.isEstimate"
                                    @click="seed(scope.row,index)"
                                >查看详情</el-button>
                                <el-button
                                    size="mini"
                                    v-if="scope.row.isend&&item.isEstimate"
                                    @click="seed(scope.row,index)"
                                >查看详情</el-button>
                                <el-button
                                    size="mini"
                                    v-if="scope.row.isend&&!item.isEstimate"
                                    type="info"
                                    disabled
                                >已结束</el-button>
                            </div>
                        </template>
                    </el-table-column>

                </el-table>
                <!-- <div class="wrap_footer clearfix">
            
            <div class="right">
              <el-pagination
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange"
                :current-page="pageIndex"
                :page-sizes="[10, 15, 20, 25]"
                :page-size="pageSize"
                layout="total, sizes, prev, pager, next, jumper"
                :total="total"
                background
              ></el-pagination>
            </div>
          </div> -->
            </el-tab-pane>
        </el-tabs>
        <el-dialog
            :visible.sync="resultVisible3"
            title="详情"
            width="75%"
            :before-close="closestufiles2"
            @close="closestufiles2"
            id="result3"
        >
            <el-table
                :data="evaDatas"
                tooltip-effect="dark"
                style="width: 100%;overflow:auto;"
                max-height="50vh"
            >
                <el-table-column
                    type="index"
                    min-width="60"
                    :index="indexMethod"
                    label="编号"
                    show-overflow-tooltip
                ></el-table-column>
                <el-table-column
                    prop="itemName"
                    label="题目"
                    show-overflow-tooltip
                ></el-table-column>
                <el-table-column
                    prop="score"
                    label="分值"
                    show-overflow-tooltip
                >
                    <template slot-scope="scope">
                        <span v-if="scope.row.score=='0'">-</span>
                        <span v-else>{{scope.row.score}}</span>
                    </template>
                </el-table-column>
                <el-table-column
                    prop="content"
                    label="填空"
                    show-overflow-tooltip
                >
                    <template slot-scope="scope">
                        <span v-if="scope.row.content">{{scope.row.content}}</span>
                        <span v-else>-</span>
                    </template>
                </el-table-column>
            </el-table>
        </el-dialog>
    </div>
</template>

<script>
export default {
    name: "confirm",
    data() {
        return {
            RecordData: [],
            isFirstEnter: false,
            total: 0,
            loading: false,
            resultVisible3: false,
            evadetailForm: {
                sheetId: "",
                classId: "",
                studentId: "",
                teacherId: "",
                name: "",
                pageIndex: "",
                pageSize: "",
            },
            //  当前页
            pageIndex: 1,
            pageSize: 10,
            assForm: {
                pageIndex: 1,
                pageSize: 10,
                termId: "",
            },
            assitemForm: {
                id: "",
            },
            evaDatas: [],
            spanArr: [],
            mainData: [],
            termData: [],
        };
    },
    filters: {
        formatDate: function (value) {
            let date = new Date(parseInt(value));
            let y = date.getFullYear();
            let MM = date.getMonth() + 1;
            MM = MM < 10 ? "0" + MM : MM;
            let d = date.getDate();
            d = d < 10 ? "0" + d : d;
            let h = date.getHours();
            h = h < 10 ? "0" + h : h;
            let m = date.getMinutes();
            m = m < 10 ? "0" + m : m;
            let s = date.getSeconds();
            s = s < 10 ? "0" + s : s;
            return y + "-" + MM + "-" + d + " " + h + ":" + m + ":" + s;
        },
    },
    created() {
        this.$global.activeMenu = "3-2";
    },
    async mounted() {
        await this.getterm();
        await this.queryLessonsplandetail();
    },
    watch: {},
    methods: {
        closestufiles2() {
            this.resultVisible3 = false;
        },
        contrastTime(end) {
            var dB = new Date(end.replace(/-/g, "/")); //获取当前选择日期
            var d = new Date();
            var str =
                d.getFullYear() + "-" + (d.getMonth() + 1) + "-" + d.getDate(); //获取当前实际日期
            if (Date.parse(str) > Date.parse(dB)) {
                //时间戳对比
                return true;
            }
            return false;
        },
        async seed(row, index) {
            let me = this;
            let param = {
                sheetId: row.sheetId,
                classId: row.classId,
                studentId: null,
                teacherId: row.teacherDatas[index].id,
                name: "",
                pageIndex: "",
                pageSize: "",
            };
            let userinfo = window.sessionStorage.getItem("userinfo");
            userinfo = JSON.parse(userinfo);
            param.studentId = userinfo.id;
            let res = await this.$team.queryEstimateDetailByStudent(param);
            if (res.success) {
                this.resultVisible3 = true;
                me.evaDatas = res.content;
            }
        },
        search() {
            this.RecordData = [];
            this.queryLessonsplandetail();
        },
        indexMethod(index) {
            return (index += 1);
        },
        // 处理每页显示数量
        handleSizeChange(val) {
            this.pageSize = val;
            this.getTerm();
        },
        // 处理翻页
        handleCurrentChange(val) {
            this.pageIndex = val;
            this.getTerm();
        },

        async queryLessonsplandetail() {
            let me = this;
            let param = me.assForm;
            param.pageIndex = me.pageIndex;
            param.pageSize = me.pageSize;
            let res = await me.$userService.queryEvaluationSheet(param);
            if (res && res["success"]) {
                me.RecordData = res.content;
                me.RecordData.forEach(function (item, index) {
                    item.isend = me.contrastTime(item.endTime);
                    item.teacherNames = item.teacherNames.split(",");
                });
            }
        },
        assement(row, index) {
            this.$router.replace({
                name: "AssessmentDetail",
                query: {
                    orderdatas: JSON.stringify(row),
                    index: index,
                },
            });
        },
        async getterm() {
            let me = this;
            let param = {
                pageIndex: 1,
                pageSize: 10,
            };
            //  查询学期信息
            let term = await me.$recruitService.queryTerm(param);
            if (term && term.success) {
                me.termData = term.content.records;
            }
        },
    },
};
</script>

<style lang="scss">
@import "../../assets/less/global.less";
@import "../../assets/css/icon.css";
@import "../../assets/css/app.css";
#Assessment {
    .el-table td {
        padding: 0px;
    }
    .el-table .cell {
        padding-left: 5px;
    }
    .el-table .cell.el-tooltip {
        padding: 0px;
        div.bor {
            border-bottom: 1px solid #ebeef5;
        }
        div.bor:nth-child(2) {
            border: none;
        }
        div {
            padding: 10px;
        }
    }
}
</style>


// WEBPACK FOOTER //
// src/components/Assessment/Assessment.vue